/* eslint no-barrel-files/no-barrel-files: off -- Alloy's synchronous dynamic transform requires direct named exports from this shared chunk. */
import type {IssuesRouteComponents} from './create-issues-routes'
import {IssueNew} from './IssueNew'
import {IssueNewChoose} from './IssueNewChoose'
import {IssuesIndexContent} from './IssuesIndexContent'
import {IssuesLayout} from './IssuesLayout'
import {Labels} from './Labels'
import {MilestoneEdit} from './MilestoneEdit'
import {MilestoneIndex} from './MilestoneIndex'
import {MilestoneNew} from './MilestoneNew'

export {IssueNew, IssueNewChoose, IssuesIndexContent, IssuesLayout, Labels, MilestoneEdit, MilestoneIndex, MilestoneNew}

export const issuesRouteComponents = {
  IssueNewChoose,
  IssuesIndexContent,
  IssuesLayout,
  IssueNew,
  Labels,
  MilestoneEdit,
  MilestoneNew,
  MilestoneIndex,
} satisfies IssuesRouteComponents
